import axios from "axios";

const TEMPERATURE_URI_PREFIX = "/v1/temperaturecontrols";
export const TEMPERATURE_URIS = {
  GET_LIST_TEMPERATURE: `${TEMPERATURE_URI_PREFIX}?`,
  ADD_TEMPERATURE: `${TEMPERATURE_URI_PREFIX}`,
  EDIT_TEMPERATURE: `${TEMPERATURE_URI_PREFIX}`,
  DELETE_TEMPERATURE: `${TEMPERATURE_URI_PREFIX}?pids=`,
  EXPORT_LIST_TEMPERATURE: `${TEMPERATURE_URI_PREFIX}/export`,
  IMPORT_TEMPERATURE: `${TEMPERATURE_URI_PREFIX}/import?`,
  GET_LIST_IMPORT_CONTINUE: `${TEMPERATURE_URI_PREFIX}/confirm`,
  IMPORT_TEMPERATURE_FINISH: `${TEMPERATURE_URI_PREFIX}/import/finish`,
  DOWNLOAD_ERROR_FILE: `${TEMPERATURE_URI_PREFIX}/download-error-file`,
};

export default {
  getListTemperature(params, signal) {
    return axios.get(TEMPERATURE_URIS.GET_LIST_TEMPERATURE, { params, signal });
  },
  addTemperature(params) {
    return axios.post(TEMPERATURE_URIS.ADD_TEMPERATURE, params);
  },
  editTemperature(params) {
    return axios.put(TEMPERATURE_URIS.EDIT_TEMPERATURE, params);
  },
  deleteTemperature(params) {
    return axios.delete(TEMPERATURE_URIS.DELETE_TEMPERATURE + params);
  },
  exportListTemperature(params) {
    // filter by selection pIds or default
    const searchParams = JSON.stringify(params).includes("pIds")
      ? params
      : new URLSearchParams(params);
    const link = `${TEMPERATURE_URIS.EXPORT_LIST_TEMPERATURE}?${searchParams}`;
    window.open(link);
  },
  importTemperature(params) {
    return axios.post(TEMPERATURE_URIS.IMPORT_TEMPERATURE, params);
  },
  importTemperatureContinue(params) {
    return axios.post(TEMPERATURE_URIS.IMPORT_TEMPERATURE_FINISH, params);
  },
  getListeConfirmTemperature(params) {
    return axios.get(TEMPERATURE_URIS.GET_LIST_IMPORT_CONTINUE, { params });
  },
  downloadErrorTemperature(errorId) {
    return axios.get(TEMPERATURE_URIS.DOWNLOAD_ERROR_FILE, {
      responseType: "arraybuffer",
      params: {
        errorId,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/services/temperature-service.js